module.exports = __webpack_public_path__ + "static/commercial.bc1d4122.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/commercial.jpg
// module id = 659
// module chunks = 0